module.exports = __webpack_public_path__ + "img/leaderboardcup.3baf4a0c.svg";